import React, { useEffect } from "react";

export const Analytics = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      let analyticsScript = document.createElement("script");
      analyticsScript.setAttribute("async", true);
      analyticsScript.setAttribute(
        "src",
        "https://www.googletagmanager.com/gtag/js?id=UA-75546602-5"
      );

      let gTagContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag("js", new Date());
  
        gtag("config", "UA-75546602-5");
        `;

      let gTag = document.createElement("script");
      gTag.innerHTML = gTagContent;

      document
        .querySelector("head")
        .appendChild(analyticsScript)
        .appendChild(gTag);
    }
  }, []);
  return <></>;
};
